import React, { Component } from "react";
import { withLocalize, Translate } from "react-localize-redux";
import translations from "../../translations/verify.json";
import no_result from "../../assets/common/not-found-img.png";
import "../../styles/components/notFound.scss";

class NotFound extends Component {
	constructor(props) {
		super(props);
		this.props.addTranslation(translations);
	}
	render() {
		return (
			<div id="not-found">
				<div
					className="main-container-verify"
					style={{
						flexDirection: "column",
						height: "450px",
						justifyContent: "flex-start",
						width: "fit-content",
					}}
				>
					<img alt="Not Found" src={no_result} className="not-found-img" />
					<span className="not-found-title">Oops!</span>
					<span className="not-found-desc">
						<Translate
							id={
								this.props.errorMessage === "deleted"
									? "deleted2"
									: this.props.errorMessage
							}
						/>
					</span>
					{this.props.handleMailTo && (
						<div
							className="report-issue"
							onClick={() => {
								this.props.errorMessage === "deleted"
									? this.props.handleMailTo("deletedCertificate")
									: this.props.handleMailTo("reportNotFound");
							}}
						>
							<Translate
								id={
									this.props.errorMessage === "deleted"
										? "contactIssuer"
										: "reportIssue"
								}
							/>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default withLocalize(NotFound);
